export const ROUTES = {
  WORKSPACES: 'workspaces',
  LOGIN: 'login',
  SIGNUP: 'signup',
  CALLBACK: 'callback',
  MAGICLINK_VERIFY: 'magiclink-verify',
  ROOT: '/'
} as const;

export const AUTH_ROUTES = [
  `/${ROUTES.LOGIN}`,
  `/${ROUTES.SIGNUP}`,
  `/${ROUTES.CALLBACK}`,
  `/${ROUTES.MAGICLINK_VERIFY}`
];
